module.exports = __webpack_public_path__ + "static/rawpixel-574844-unsplash-85b57e29ef582c9f1d8c0740476ecddf.jpg";